import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzResultModule } from "ng-zorro-antd/result";
import { HeaderModule } from "../components/header/header.module";
import { SharedModule } from "../shared/shared.module";
import { PagesRoutingModule } from "./pages-routing.module";
import { PagesComponent } from "./pages.component";

@NgModule({
  declarations: [PagesComponent],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    NzBadgeModule,
    NzLayoutModule,
    HeaderModule,
    NzResultModule,
    TranslateModule,
    NzMenuModule,
    NzIconModule,

  ],
  providers: [NzModalService],
})
export class PagesModule {}
